<template>
  <div>
    <Transfer_goods/>
  </div>
</template>

<script>
import Transfer_goods from "@/components/adminArin/pos_system/warehouse/warehouse_all/Transfer_goods";
export default {
  name: "Transfergoods",
  components: {
    Transfer_goods
  }
}
</script>

<style scoped>

</style>
